/** @deprecated Use `~/components/build/Show/routes/list/-components/EmptyState` instead. */
export default function EmptyState() {
  return <div className="px-2">No steps match the selected filters.</div>;
}
